import Modal from '../Modal';
import AudiencesList from './AudiencesList.jsx';

const AudiencesModal = () => {
  return Modal({
    component: <AudiencesList />,
    width: '394px',
    padding: '24px',
  });
};

export default AudiencesModal;
